export interface WaterfallItem {
  label: string;
  amountText: string;
  pctText: string;
  leftPct: number;
  widthPct: number;
  color: string;
  bold?: boolean;
}

/** 損益ブレークダウン（横フロート棒）。design README §2-2。 */
export function Waterfall({ items }: { items: WaterfallItem[] }) {
  return (
    <div className="pl-waterfall">
      {items.map((w, i) => (
        <div className="pl-waterfall-row" key={`${w.label}-${i}`}>
          <span className="pl-waterfall-label" style={{ fontWeight: w.bold ? 600 : 400 }}>
            {w.label}
          </span>
          <div className="pl-waterfall-track">
            <div
              className="pl-waterfall-bar"
              style={{ left: `${w.leftPct}%`, width: `${Math.max(0, w.widthPct)}%`, background: w.color }}
            />
          </div>
          <span className="pl-waterfall-amt" style={{ fontWeight: w.bold ? 600 : 400 }}>
            {w.amountText}
          </span>
          <span className="pl-waterfall-pct">{w.pctText}</span>
        </div>
      ))}
    </div>
  );
}
